var map = {
	"./account/address/address.module": [
		"./src/app/account/address/address.module.ts",
		"account-address-address-module"
	],
	"./account/city/city.module": [
		"./src/app/account/city/city.module.ts",
		"account-city-city-module"
	],
	"./account/forgot/forgot.module": [
		"./src/app/account/forgot/forgot.module.ts",
		"account-forgot-forgot-module"
	],
	"./account/login/login.module": [
		"./src/app/account/login/login.module.ts",
		"account-login-login-module"
	],
	"./account/order/order.module": [
		"./src/app/account/order/order.module.ts",
		"account-order-order-module"
	],
	"./account/profile/profile.module": [
		"./src/app/account/profile/profile.module.ts",
		"account-profile-profile-module"
	],
	"./account/rate/rate.module": [
		"./src/app/account/rate/rate.module.ts",
		"account-rate-rate-module"
	],
	"./account/signup/signup.module": [
		"./src/app/account/signup/signup.module.ts",
		"account-signup-signup-module"
	],
	"./cart/cart.module": [
		"./src/app/cart/cart.module.ts",
		"cart-cart-module"
	],
	"./checkout/checkout.module": [
		"./src/app/checkout/checkout.module.ts",
		"checkout-checkout-module"
	],
	"./done/done.module": [
		"./src/app/done/done.module.ts",
		"done-done-module"
	],
	"./info/info.module": [
		"./src/app/info/info.module.ts",
		"info-info-module"
	],
	"./item/item.module": [
		"./src/app/item/item.module.ts",
		"item-item-module"
	],
	"./lang/lang.module": [
		"./src/app/lang/lang.module.ts",
		"lang-lang-module"
	],
	"./offer/offer.module": [
		"./src/app/offer/offer.module.ts"
	],
	"./option/option.module": [
		"./src/app/option/option.module.ts"
	],
	"./page/about/about.module": [
		"./src/app/page/about/about.module.ts",
		"page-about-about-module"
	],
	"./page/contact/contact.module": [
		"./src/app/page/contact/contact.module.ts",
		"page-contact-contact-module"
	],
	"./page/faq/faq.module": [
		"./src/app/page/faq/faq.module.ts",
		"page-faq-faq-module"
	],
	"./page/how/how.module": [
		"./src/app/page/how/how.module.ts",
		"page-how-how-module"
	],
	"./welcome/welcome.module": [
		"./src/app/welcome/welcome.module.ts",
		"welcome-welcome-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;